module.exports = __webpack_public_path__ + "static/media/Aircrack-ng-new-logo.5ee1865c.png";